module.exports = __webpack_public_path__ + "svg/ra-pros.94c97d3.svg";